<div class="container mx-auto px-4 py-6">
  <div class="mb-6 flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-bold text-gray-800">⭐ Destaque da Semana</h1>
      <p class="text-gray-600 mt-2">Gestão do popup de destaque da semana</p>
    </div>
    <a routerLink="/admin/destaques-semana/new" class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700">
      + Novo Destaque
    </a>
  </div>

  <div class="bg-white rounded-lg shadow p-6 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select [(ngModel)]="filtroAtivo" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option value="">Todos</option>
          <option value="true">Ativo</option>
          <option value="false">Inativo</option>
        </select>
      </div>
      <div class="flex items-end gap-2">
        <button (click)="load()" class="px-4 py-2 bg-blue-600 text-white rounded-md">Filtrar</button>
        <button (click)="resetFilters()" class="px-4 py-2 border rounded-md hover:bg-gray-50">Limpar</button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Imagem</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fornecedor (Slug)</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data Inicial</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data Final</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let item of items" class="hover:bg-gray-50">
            <td class="px-6 py-4">
              <img [src]="item.imageUrl" alt="Destaque" class="w-24 h-16 object-cover rounded border" *ngIf="item.imageUrl">
              <span *ngIf="!item.imageUrl" class="text-gray-400 text-sm">—</span>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900">{{ item.fornecedorSlug }}</div>
              <div class="text-xs text-gray-500">ID: {{ item.id }}</div>
            </td>
            <td class="px-6 py-4 text-sm">{{ item.dataInicial | date:'dd/MM/yyyy' }}</td>
            <td class="px-6 py-4 text-sm">{{ item.dataFinal | date:'dd/MM/yyyy' }}</td>
            <td class="px-6 py-4">
              <span [class]="'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' + (item.isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800')">
                {{ item.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
              <button (click)="edit(item)" class="text-blue-600 hover:text-blue-900">Editar</button>
              <button (click)="remove(item)" class="text-red-600 hover:text-red-900">Remover</button>
            </td>
          </tr>
          <tr *ngIf="items.length === 0">
            <td colspan="6" class="px-6 py-12 text-center text-gray-500">
              Nenhum destaque da semana cadastrado.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex items-center justify-between">
        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p class="text-sm text-gray-700">
              Mostrando
              <span class="font-medium">{{ items.length > 0 ? (page - 1) * pageSize + 1 : 0 }}</span>
              até
              <span class="font-medium">{{ displayEnd() }}</span>
              de
              <span class="font-medium">{{ total }}</span>
              resultados
            </p>
          </div>
          <div>
            <app-pagination [page]="page" [pageSize]="pageSize" [total]="total" (pageChange)="onPageChange($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
